export default "__VITE_ASSET__CHOHTYn8__"